(function() {

     require('../../../vendor/fbGallery.js');

     $("#jsFacebookPhotos").FacebookAlbumBrowser({
           account: "huishurenibiza.nl",
           accessToken: "340977396346403|88d8860bc6fc27bc953dfc3b980e6db6",
           showComments: false,
           showAccountInfo: false,
           showImageCount: false,
           showImageText: false,
           shareButton: false,
           showImageCount: 2,
           albumsPageSize: 2,
           albumsPageSize: 2,
       });

})();
